import { useContext, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { AuthContext } from '../../contexts/AuthContext'

import { Footer, Wrapper } from 'components'
import { useNavigate } from 'react-router-dom'
import { Button, Card, Input, toast } from 'keep-react'
import { RouteNamesNonAuth } from 'routes/enum'
import { Eye, EyeSlash } from 'phosphor-react'

const validationSchema = Yup.object().shape({
  username: Yup.string().email().required('Email é obrigatório'),
  password: Yup.string().required('Password é obrigatória'),
})

export const Login = () => {
  const { login } = useContext(AuthContext)
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false)
  const [passwordFieldType, setPasswordFieldType] = useState<
    'password' | 'text'
  >('password')
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues: { username: '', password: '' },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema,
    onSubmit: async values => {
      setIsLoggingIn(true)
      try {
        await login({
          email: values.username,
          password: values.password,
        })
        navigate('/dashboard')
      } catch (err) {
        toast.error('Erro ao iniciar sessão.')
      } finally {
        setIsLoggingIn(false)
      }
    },
  })

  return (
    <div
      className="w-screen h-screen bg-cover bg-no-repeat bg-center flex items-center"
      style={{
        backgroundImage: `url(images/dark_broker.jpg)`,
      }}
    >
      <Wrapper>
        <div className="flex flex-col items-center m-auto gap-x-4 gap-y-12 max-w-[700px] h-full">
          <h1 className="text-white uppercase font-semibold text-2xl text-center tracking-wider">
            Seguros à velocidade de um foguetão
          </h1>
          <div className="grid grid-cols-2 gap-12 items-center w-full">
            <div className="flex flex-col gap-6">
              <Card className="w-full bg-white/70 p-4 rounded-xl max-w-none">
                <h2 className="font-light text-heading-6 text-primary-400 pb-4 uppercase">
                  Login
                </h2>
                <form onSubmit={formik.handleSubmit}>
                  <div className="space-y-5">
                    <Input
                      type="email"
                      name="username"
                      onChange={formik.handleChange}
                      placeholder="Email"
                      className="px-2"
                    />

                    <div className="relative">
                      <Input
                        type={passwordFieldType}
                        name="password"
                        onChange={formik.handleChange}
                        placeholder="Password"
                        className="px-2"
                      />
                      <Button
                        type="button"
                        shape="icon"
                        color="secondary"
                        className="absolute top-1/2 right-3 -translate-y-1/2 p-0 text-metal-900 bg-transparent hover:bg-transparent"
                        onClick={() => {
                          if (passwordFieldType === 'password') {
                            setPasswordFieldType('text')
                          } else {
                            setPasswordFieldType('password')
                          }
                        }}
                      >
                        {passwordFieldType === 'password' ? (
                          <Eye size={16} />
                        ) : (
                          <EyeSlash size={16} />
                        )}
                      </Button>
                    </div>
                  </div>

                  <div className="space-y-2 mb-5">
                    <div className="flex justify-end">
                      <Button
                        type="button"
                        color="primary"
                        variant="link"
                        className="underline text-body-5 cursor-pointer"
                        onClick={() => {
                          navigate(RouteNamesNonAuth.REQUEST_NEW_PASSWORD)
                        }}
                      >
                        Recuperar password
                      </Button>
                    </div>
                  </div>
                  <Button
                    className="w-full"
                    type="submit"
                    disabled={isLoggingIn}
                  >
                    Entrar
                  </Button>
                </form>
              </Card>

              <Card className="w-full bg-white/70 p-4 rounded-xl mt-6 max-w-none">
                <div className="space-y-6">
                  <h2 className="font-light text-heading-6 text-primary-400 uppercase">
                    Registo
                  </h2>
                  <p>Ainda não trabalha connosco?</p>
                  <Button
                    onClick={() => navigate(RouteNamesNonAuth.REGISTER)}
                    variant="default"
                    color="primary"
                    className="w-full"
                  >
                    pedir nomeação
                  </Button>
                </div>
              </Card>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src="/images/rocket.svg"
                alt="Innovarisk"
                className="max-w-[220px] animate-slideInFade"
              />
              <h2 className="text-white font-roboto mb-[50px] mt-[50px] text-lg text-center">
                A solução que permite de forma simples e fácil aceder aos
                produtos especializados para nichos de mercado.{' '}
              </h2>
            </div>
          </div>
        </div>
      </Wrapper>
      <Footer />
    </div>
  )
}
